import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=54609f2a&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=54609f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54609f2a",
  null
  
)

export default component.exports